import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddProjectRegionRequest } from '../models/request/projectRegion/AddProjectRegionRequest';
import { GetProjectRegionListPagingAndFilterRequest } from '../models/request/projectRegion/GetProjectRegionListPagingAndFilterRequest';
import { CustomSingleSelectModel } from '../components/CustomSingleSelect';

export class ProjectRegionService {
    static async getProjectRegionList(_selectedCounty: CustomSingleSelectModel | undefined = undefined, _selectedDistrict: CustomSingleSelectModel | undefined = undefined, _selectedNeighborhood: CustomSingleSelectModel | undefined, _selectedCarryTypes: CustomSingleSelectModel[] | undefined, _selectedProject: CustomSingleSelectModel | undefined) {
        try {
            var inputObj = {
                selectedCounty: _selectedCounty,
                selectedDistrict: _selectedDistrict,
                selectedNeighborhood: _selectedNeighborhood,
                selectedCarryTypes: _selectedCarryTypes,
                selectedProject: _selectedProject
            };

            console.log('SERVICE CALL - getProjectRegionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ProjectRegion/getProjectRegionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportProjectRegionList(inputObj: GetProjectRegionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportProjectRegionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ProjectRegion/exportProjectRegionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getProjectRegionListPagingAndFilter(inputObj: GetProjectRegionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetProjectRegionListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ProjectRegion/GetProjectRegionListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addProjectRegion(inputObj: AddProjectRegionRequest) {
        try {
            console.log('SERVICE CALL - AddProjectRegion', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ProjectRegion/AddProjectRegion', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteProjectRegion(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteProjectRegion', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ProjectRegion/deleteProjectRegion', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getProjectRegionById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getProjectRegionById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ProjectRegion/getProjectRegionById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}